import React from 'react'
import classNames from 'classnames'

type ResourceCardSkeletonProps = {
  className?: string
}

export const ResourceCardSkeleton: React.FC<ResourceCardSkeletonProps> = ({
  className: classNameFromProps,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-col rounded-md overflow-hidden bg-white border border-border-subtle',
        classNameFromProps,
      )}
    >
      <div className="flex flex-col p-4 relative">
        {/* Top section: Icon and Badge */}
        <div className="flex items-start justify-between mb-6">
          {/* Icon placeholder */}
          <div className="size-9 rounded-sm bg-blue-90 animate-pulse"></div>
          {/* Free Badge placeholder */}
          <div className="w-12 h-5 bg-neutral-90 rounded animate-pulse"></div>
        </div>

        {/* Title placeholder */}
        <div className="mb-4">
          <div className="w-3/4 h-6 bg-neutral-90 rounded animate-pulse mb-2"></div>
          <div className="w-1/2 h-6 bg-neutral-90 rounded animate-pulse"></div>
        </div>

        {/* Description placeholder */}
        <div className="mb-4 space-y-2">
          <div className="w-full h-3 bg-neutral-90 rounded animate-pulse"></div>
          <div className="w-5/6 h-3 bg-neutral-90 rounded animate-pulse"></div>
          <div className="w-4/6 h-3 bg-neutral-90 rounded animate-pulse"></div>
        </div>

        {/* Date and File Type placeholder */}
        <div className="flex items-center gap-2 mb-4">
          <div className="w-20 h-3 bg-neutral-90 rounded animate-pulse"></div>
          <div className="w-1 h-1 rounded-full bg-neutral-90"></div>
          <div className="w-16 h-3 bg-neutral-90 rounded animate-pulse"></div>
        </div>

        {/* Tag placeholder */}
        <div className="mb-6">
          <div className="w-24 h-5 bg-neutral-90 rounded animate-pulse"></div>
        </div>

        {/* Author placeholder */}
        <div className="flex items-center gap-3 bg-bg-subtle p-2 rounded-md mb-6">
          <div className="w-8 h-8 rounded-full bg-neutral-90 animate-pulse"></div>
          <div className="flex-1">
            <div className="w-24 h-3 bg-neutral-90 rounded animate-pulse mb-1"></div>
            <div className="w-32 h-2 bg-neutral-90 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Download Button placeholder */}
        <div className="w-full h-12 bg-neutral-90 rounded animate-pulse"></div>
      </div>
    </div>
  )
}

